export const HIDDEN_SECTION = "[data-section-visibility-target~='section'][aria-hidden='true']"

export const toggleSectionVisibility = (section, visible) => {
  if (!section) return

  section.classList.toggle("tw-hidden", !visible)
  section.setAttribute("aria-hidden", (!visible).toString())

  section.querySelectorAll("input, select, textarea").forEach((input) => {
    input.disabled = !visible || Boolean(input.closest(HIDDEN_SECTION))
  })
}
